<template>
  <b-col
    xl="7"
    md="12"
    sm="12"
  >
    <b-card no-body>
      <div class="bg-light-primary rounded-top text-center" />
      <b-card-header class="align-items-baseline border-bottom">
        <!-- Title Starts -->
        <b-row
          class="w-100"
        >
          <b-col class="col-11">
            <b-card-title
              class="font-medium-5 text-dark"
            >
              <b-link
                class="text-dark"
                :href="titleData.pageUrl"
                target="_blank"
                v-html="titleData.videoLabel"
              />
            </b-card-title>
          </b-col>
          <b-col class="col-1">
            <b-button
              variant="dark"
              class="btn-icon"
              @click="closeDetails"
            >
              <feather-icon
                icon="XIcon"
                size="14"
                class="text-muted cursor-pointer"
              />
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>
      <!-- Title Ends -->
      <b-card-body>
        <b-col
          xl="12"
          md="12"
          sm="12"
        >
          <b-row
            class="mt-1 d-flex justify-content-around"
          >
            <!-- Video Image Start -->
            <b-col
              xl="2"
              md="12"
              sm="2"
              class="mt-1"
            >
              <b-img
                center
                fluid
                :src="titleData.videoPosterUrl"
                alt=""
                width="120"
              />
            </b-col>
            <!-- Video Image End -->
            <b-col
              xl="10"
              md="12"
              sm="12"
              class="text-left mt-1"
            >
              <!-- Video ID Start -->
              <b-row>
                <b-col
                  cols="3"
                  class="font-weight-bolder"
                >
                  {{ $t('Video ID') }}
                </b-col>
                <b-col
                  cols="8"
                  class="text-left"
                >
                  {{ titleData.videoId || "n/a" }}
                </b-col>
              </b-row>
              <!-- Video ID End -->
              <!-- Video Duration Start -->
              <b-row>
                <b-col
                  cols="3"
                  class="font-weight-bolder"
                >
                  {{ $t('Duration') }}
                </b-col>
                <b-col
                  cols="8"
                  class="text-left"
                >
                  {{ titleData.videoDuration || "n/a" }}
                </b-col>
              </b-row>
              <!-- Video Duration End -->
              <!-- Video Publish Date Start -->
              <b-row>
                <b-col
                  cols="3"
                  class="font-weight-bolder"
                >
                  {{ $t('Publish Date') }}
                </b-col>

                <b-col
                  cols="8"
                  class="text-left"
                >
                  {{ titleData.videoPublishedDate || "n/a" }}
                </b-col>
              </b-row>
              <!-- Video Publish Date End -->
            </b-col>
          </b-row>
        </b-col>
      </b-card-body>
    </b-card>
  </b-col>
</template>

<script>
import {
    BRow, BCol, BCard, BCardTitle, BButton, BCardHeader, BImg, BLink, BCardBody, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardTitle,
        BButton,
        BCardHeader,
        BImg,
        BLink,
        BCardBody,
    },
    directives: {
        Ripple,
        'b-tooltip': VBTooltip,
    },
    props: {
        titleData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {}
    },
    methods: {
        isMobile() {
            return window.innerWidth < 768
        },
        closeDetails() {
            this.$emit('closeDetails')
        },
    },
}
</script>
